<template lang="pug">
  #Profile
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 個人資料
    .container-width
      .pt-3.px-4.text-center.mb-5(
          v-if="profile"
        )
        .mb-3
          ProfilePhotoSticker.ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
            :profileUrl="profileImgUrl",
            :style="{ 'width': '100px', 'height': '100px' }",
            :changeProfile="true",
            @changeProfileImgHandler="changeProfileImgHandler"
          )
          input.d-none(
            type="file",
            accept="image/*",
            id="imageUpload",
            @change="imageUploadHandler",
            ref="imageUploadInput"
          )
        p.text-center 請美容顧問上傳形象照
        .crop.mb-4(v-show="isCropperShow")
          .cropper-area
            img#cropImg
          .button-area
            .col-6
              button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
                type="button",
                @click="getCropperImage",
                style="border: 4px solid #000;border-radius: 50px;padding: 0px 15px;box-shadow: 0.2rem 0.2rem 0 #00000033;",
              ) 確定
            .col-6
              button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
                type="button",
                @click="cancelCropperImage",
                style="border: 4px solid #000;border-radius: 50px;padding: 0px 15px;box-shadow: 0.2rem 0.2rem 0 #00000033;",
              ) 取消

        .input_wrap.input_wrap-name
          input.profile_name(
            type='text',
            name='profile_name',
            v-model='preferred_name',
            maxlength="20",
            placeholder="顯示名稱限制為20字內",
          )
          .profile_name_icon(
            @click.stop.prevent='changeProfilePreferredNameHandler("name")'
          )
            i.fas.fa-pencil-alt
        .input_wrap.mt-3
          .profile_skill
            p(
              :class="{'grey': skills.length==0}"
            ) {{ skill_name }}
          .profile_name_icon(
            @click.stop.prevent='openSkillsModel'
          )
            i.fas.fa-pencil-alt
        .input_wrap.input_wrap-switch.my-3
          .profile_switch_wrap
            .profile_switch_text
              span  非上班時段預設回覆訊息
            .profile_switch(:class="{ 'active': is_auto_reply}" @click.stop.prevent='switchAutoReplyHandler')
              .profile_switch_btn
                label(v-if="is_auto_reply") 開
                label(v-else style='color: #FFFFFF') 關
          textarea.mt-2#profile_message(name='profile_message' cols='30' rows='8', v-model="message")
        .row.justify-content-center.align-items-center.h-100
          .col-6
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
              type="button",
              @click="saveHandler()",
              style="border: 4px solid #000;border-radius: 50px;padding: 0px 15px;box-shadow: 0.2rem 0.2rem 0 #00000033;",
            ) 確定
    .container-bottom
    BaSkillsModel(
      title="個人特色設定",
      :list="skillsList"
      :selectList="skills"
      @saveSkills="saveHandler"
    )
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import defaultPhotoUrl from '@/assets/images/default/defaultProfileImg.png';
import { VueCropper } from 'vue-cropper';
import BaSkillsModel from '@/components/customerModel/baSkillsModel.vue';

import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";

export default {
  name: 'ProfileIndex',
  components: {
    ProfilePhotoSticker,
    VueCropper,
    Cropper,
    BaSkillsModel
  },
  data() {
    return {
      preferred_name: null,
      is_auto_reply: 0,
      message: '',
      skills:[],
      img: `${defaultPhotoUrl}`,
      isCanSend: false,
      CROPPER: null,
      isCropperShow:false
    };
  },
  created() {
    const vm = this;
    vm.initHandler();
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 取得個人資料
      vm.$store.dispatch('sa_profile/getProfileHandler')
        .then(() => {
          vm.$swal.close();
          vm.preferred_name = vm.profile.preferred_name;
          vm.is_auto_reply = vm.profile.non_work_reply_status;
          vm.message = vm.profile.non_work_reply_message;
          vm.skills = vm.profile.skills;
          vm.$store.commit('toggleLoading', false);
        });
    },
    changeProfileImgHandler() {
      this.$refs.imageUploadInput.click();
    },
    imageUploadHandler(eve) {
      if (this.CROPPER) this.CROPPER.destroy();
      let reader = new FileReader();
      if (event.target.files[0]) {
        reader.readAsDataURL(eve.target.files[0]);
        reader.onload = () => {
          this.isCropperShow = true;
          this.$nextTick(() => {
            let dataURL = reader.result;
            document.querySelector("#cropImg").src = dataURL;
            const image = document.getElementById("cropImg");
            this.CROPPER = new Cropper(image, {
              aspectRatio: 16 / 16,
              viewMode: 0,
              minContainerWidth: 100,
              minContainerHeight: 100,
              dragMode: "move",
              // preview: [document.querySelector(".preview-box")],
            });
          });
        };
      }
    },
    cancelCropperImage() {
      let obj = this.$refs.imageUploadInput;
      obj.value = null;
      this.isCropperShow = false;
    },
    getCropperImage() {
      this.CROPPER.getCroppedCanvas({
        maxWidth: 500,
        maxHeight: 500,
        fillColor: "#fff",
        imageSmoothingEnabled: true,
        imageSmoothingQuality: "high",
      }).toBlob((blob) => {
        const vm = this;
        vm.$swal.fire({
          title: '上傳中',
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });
        const formData = new FormData();
        formData.append("file", blob);
        vm.$store.dispatch('sa_profile/changeProfilePictureHandler', formData)
          .then(() => {
            vm.$store.dispatch('sa_profile/getProfileHandler');
            vm.$refs.imageUploadInput.value = null;
            vm.isCropperShow = false;
            vm.$swal.close();
          });
      });
    },
    cancelChangeProfileImg() {
      const vm = this;
      vm.$refs.imageUploadInput.value = null;
      vm.isChangingProfileImg = false;
    },
    routerBack() {
      this.$router.back();
    },
    openSkillsModel() {
      const vm = this;
      vm.$EventBus.$emit('openBaSkillsModel');
    },
    switchAutoReplyHandler() {
      const vm = this;
      if (vm.is_auto_reply) {
        vm.is_auto_reply = 0;
      } else {
        vm.is_auto_reply = 1;
      }
      vm.switchAutoReply();
    },
    changeProfilePreferredNameHandler(type) {
      const vm = this;

      if (vm.preferred_name === '' || vm.preferred_name === null) {
        vm.$swal.fire({
          icon: 'info',
          title: '請輸入顯示名稱'
        });
        return;
      }

      if (vm.preferred_name.length > 20) {
        vm.$swal.fire({
          icon: 'info',
          title: '顯示名稱限制為20字內'
        });
        return;
      }
      if(type == 'name') {
        vm.changeProfileName();
      }else{
        return
      }
    },
    async switchAutoReply() {
      const vm = this;

      vm.isCanSend = true;
      const formData = {
        status: vm.is_auto_reply,
        message: vm.message
      };
      if (vm.isCanSend) {
        vm.$swal.fire({
          title: '更新資料中，請稍等',
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });

        vm.$store.dispatch('sa_profile/changeProfileAutoReplyMessageHandler', formData) //修改自動回覆
          .then(() => {
            setTimeout(() => {
              vm.$swal.close();
            }, 1000);
          });
      }
    },
    async changeProfileName() { //更新名稱
      const vm = this;
      vm.isCanSend = true;
      if (vm.isCanSend) {
        vm.$swal.fire({
        title: '更新顯示名稱，請稍等',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });
      const formData = {
        name: vm.preferred_name
      };
      vm.$store.dispatch('sa_profile/changeProfilePreferredNameHandler', formData) //修改姓名
        .then(() => {
          setTimeout(() => {
            vm.$swal.close();
          }, 1000);
        });
      }
    },
    async saveHandler(skills) {
      const vm = this;
      console.log(skills)
      vm.changeProfilePreferredNameHandler("save"); //驗證preferred_name

      vm.isCanSend = true;
      const formData = {
        name: vm.preferred_name,
        status: vm.is_auto_reply,
        message: vm.message,
        skills: skills? skills: vm.skills.map(item=> item.skill_id)
      };
      if (vm.isCanSend) {
        vm.$swal.fire({
          title: '更新資料中，請稍等',
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });

        vm.$store.dispatch('sa_profile/changeProfile', formData)
          .then(() => {
            vm.$swal.close();
            vm.initHandler();
          });
      }
    },
  },
  computed: {
    skill_name() {
      const vm = this;
      const len = vm.skills.length;
      if(len !== 0) {
        let sum = '';
        vm.skills.forEach((value, index) =>{
          let skillName = vm.skills[index].skill_name;
         if(index !== len -1) skillName += ',';
          sum += skillName
      });
      return sum; 
      }else{
        return '個人特色 設定'
      }
    },
    ...mapState({
      profile: (state) => state.sa_profile.data,
      skillsList: (state) => state.sa_profile.skillList,
      profileImgUrl: (state) => state.sa_profile.profileImgUrl
    })
  }
};
</script>

<style scoped>
  @font-face {
    font-family: "icon";
    src: url("../../../assets/fonts/icon.eot?hrpp7d");
    src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }
  #header_back {
    font-size: 1.7rem;
    padding: 0.5rem;
    position: absolute;
    top: 3%;
    left: 1.6rem;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: #fff !important;
    z-index: 15;
  }
  i.custom {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .icon-icon_arrowLeft {
    top: 0;
    left: 5px;
  }
  .icon-icon_arrowLeft:before {
    content: "\e907";
  }
  .icon-icon_edit:before {
    content: "\e911";
  }
  .profile_name {
    font-size: 1.2rem;
    text-align: center;
    font-weight: 600;
    padding-right: 8rem;
    padding-left: 8rem;
  }
  .input_wrap {
    position: relative;
  }
  input[type="text"], input[type="date"], select, textarea {
    border: 0;
    outline: 0;
    background-color: #eee;
    font-size: 1rem;
    padding: 0.6rem 1.5rem 0.6rem 1rem;
    border-radius: 9487px;
    width: 100%;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  .profile_skill{
    background-color: #eee;
    font-size: 1rem;
    padding: 0.6rem 2.5rem 0.6rem 1rem;
    border-radius: 9487px;
    width: 100%;
    text-align: center;
    font-weight: 600;
  }
  .profile_skill p {
    margin: 0;
  }
  .profile_skill p.grey {
    margin: 0;
    color: grey
  }
  .profile_name_icon {
    position: absolute;
    top: 50%;
    right: 1rem;
    font-size: 1.3rem;
    transform: translate(0, -50%);
    -webkit-transform: translate(0, -50%);
  }
  .profile_switch_wrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .profile_switch {
    width: 4rem;
    height: 2rem;
    background-color: #eee;
    border-radius: 9487px;
    padding: 0.5rem 0;
    cursor: pointer;
    position: relative;
  }
  .profile_switch.active .profile_switch_btn {
    background-color: #ef4852;
    left: calc(100% - 2.7rem);
  }
  .profile_switch_btn {
    width: 2.5rem;
    height: 1.5rem;
    border-radius: 20px;
    background-color: #aaa;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    position: absolute;
    top: 50%;
    left: 0.2rem;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
  }
  textarea {
    border-radius: 1rem;
    resize: none;
  }

.ProfilePhotoSticker {
  border: 2px solid #000!important;
}
.container-bottom {
  padding-bottom: 50px;
}
/* crop-area */
.crop {
  height: 200px;
  display: flex;
  flex-direction: column;
}
.cropper-area {
  flex: 1 1 0;
  overflow-y: auto;
  overflow-x: hidden;
  /* margin: 0 auto; */
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
#cropImg {
  box-shadow: 0 0 5px #adadad;
}
.button-area {
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
}
</style>
